<template>
	<div class="expression__box">
		<span class="expression__text">{{ title }}</span>
		<div class="expression__all">
			<label class="expression__all-text">
				<input type="checkbox" v-model="allModel" />
				<span>전체</span>
			</label>
		</div>
		<CheckboxList
			:ulClass="'custom-list'"
			v-model="checkedList"
			:checkboxList="data"
			valueName="expression"
			keyName="productExpressionId"
		/>
	</div>
</template>

<script>
	import CheckboxList from '../../CheckboxList.vue';

	export default {
		name: 'ExpressionSection',
		components: { CheckboxList },
		props: {
			title: {
				type: String,
				required: true,
			},
			data: {
				type: Array,
				required: true,
			},
			value: {
				type: Array,
				required: true,
			},
		},
		computed: {
			checkedList: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit('input', value);
				},
			},
			allModel: {
				get() {
					const dataIds = this.data.map(
						item => item.productExpressionId
					);
					return dataIds.every(id => this.checkedList.includes(id));
				},
				set(value) {
					const dataIds = this.data.map(
						item => item.productExpressionId
					);
					if (value) {
						this.checkedList = [
							...new Set([...this.checkedList, ...dataIds]),
						];
					} else {
						this.checkedList = this.checkedList.filter(
							id => !dataIds.includes(id)
						);
					}
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
	.expression {
		&__box {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}

		&__text {
			font-size: 15px;
			font-weight: bold;
			padding: 10px;
			border-radius: 10px;
			background-color: #e3e3e3;
		}

		&__all {
			display: flex;
			align-items: center;
			gap: 5px;
			margin-bottom: 10px;
			border-bottom: 1px solid #e3e3e3;
			padding-bottom: 10px;
			font-size: 15px;
		}

		&__all-text {
			display: flex;
			gap: 5px;
		}
	}
</style>
